import React from "react";

function SvgIcMapPoi118(props) {
  return (
    <svg width="1em" height="1em" viewBox="0 0 32 32" {...props}>
      <g fill="none" fillRule="evenodd">
        <path
          d="M22 16.549a1 1 0 01.892 1.452H25v1h-.016l.01.082.006.084v4.666l-.005.084-.011.083H25v2h-2v-1H9v1H7v-2h.016l-.01-.083L7 23.833v-4.666l.005-.084.011-.083H7v-1l11.108.001a1 1 0 111.784 0l1.216.001A1 1 0 0122 16.55zm-1.458-2.104a1 1 0 11-.001 2 1 1 0 010-2zM26 10.015v1.176h-.01a2 2 0 01-3.96.15l-.02-.15h-.02a2 2 0 01-3.96.15l-.02-.15h-.02a2 2 0 01-3.96.15l-.02-.15h-.02a2 2 0 01-3.96.15l-.02-.15h-.02a2 2 0 01-3.96.15l-.02-.15H6v-1.175h20zM24 6l2 2.969H6L8 6h16z"
          fill="#FFF"
        />
      </g>
    </svg>
  );
}

export default SvgIcMapPoi118;
